<template lang="pug">
  VueDragResize(@clicked="focusTextarea"
    @resizing="resize" @dragging="resize"
    :w="width" :h="height" :x="left" :y="top"
    :minw="minw" :minh="minh"
    :isActive="true")
    div.wrap-item-tool-preview-text
      span(@click.stop="onDrawHere").btn-set-here.fz14.cursor-pointer.px6 Draw
      div(@click.stop="cancelTool").btn-cancel.cursor-pointer
        v-icon(size="20" color="#999") mdi-close
      textarea(ref="textarea" @click.stop
        v-model="value" :style="style"
        :class="`doodle-animation-${currentAnimation}`").input-textarea
      span(ref="hiddenText"
        :style="style").hidden-text {{value}}
      div.wrap-animation-selector
        AtomToolAnimationSelector(@setCurrentAnimation="setCurrentAnimation")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/doodleAnimation.scss";

.wrap-item-tool-preview-text {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 101;
  .btn-set-here {
    position: absolute;
    left: 0;
    bottom: calc(100% + 4px);
    background: $active_color;
    border-radius: 3px;
    filter: $drop_shadow;
  }
  .btn-cancel {
    position: absolute;
    right: 0;
    bottom: calc(100% + 4px);
    color: $active_color;
  }
  .input-textarea {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    outline: none;
    resize: none;
  }
  .hidden-text {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    white-space: pre-wrap;
    word-wrap: break-word;
    visibility: hidden;
  }
  .wrap-animation-selector {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    // right: 0;
  }
}
</style>

<script>
import database from '@/database'
import VueDragResize from 'vue-drag-resize'
import AtomToolAnimationSelector from '@/components/atom/AtomToolAnimationSelector'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  components: {
    VueDragResize,
    AtomToolAnimationSelector
  },
  props: {
    posForPreview: {
      type: Object,
      required: true
    },
    showingPage: {
      type: Object,
      required: true
    },
    fontOption: {
      type: Object,
      required: true
    },
    slide: {
      type: Object,
      required: true
    },
    doodles: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      value: 'Type your doodle...',
      style: '',
      width: 172, height: 32,
      minw: 120, minh: 32,
      top: 0, left: 0,
      isSaving: false,
      currentAnimation: 'normal'
    }
  },
  watch: {
    fontOption () {
      const fo = this.fontOption
      this.style = `color: ${fo.color}; background: ${fo.backgroundColor}; font-size: ${fo.fontSize}px; font-weight: ${fo.fontWeight}; font-family: ${fo.fontFamily};`
      this.minh =  Number(fo.fontSize)
      this.$nextTick(this.resizeTextarea)
    },
    value () {
      this.resizeTextarea()
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    animatedDoodleNum () {
      return this.doodles.filter(e => e.animation && e.animation !== 'normal').length
    },
    personalMindoScore () {
      const myDoodles = this.doodles
        .filter(e => e.page === this.slide.currentPage)
        .filter(e => e.createdBy === this.uid)
      if (!myDoodles[0]) return 0
      const likeSum = myDoodles.map(d => d.likeNum)
        .reduce((sum, el) => { return sum + el }, 0)
      const dislikeSum = myDoodles.map(d => d.dislikeNum)
        .reduce((sum, el) => { return sum + el }, 0)
      return likeSum - dislikeSum
    }
  },
  created () {
    const fo = this.fontOption
    this.style = `color: ${fo.color}; background: ${fo.backgroundColor}; font-size: ${fo.fontSize}px; font-weight: ${fo.fontWeight}; font-family: ${fo.fontFamily};`
    this.minh = Number(fo.fontSize)
    this.height = Number(fo.fontSize)

    this.top = this.posForPreview.y
    this.left = this.posForPreview.x
  },
  async mounted () {
    await this.sleep(400)
    this.resizeTextarea()
    this.$nextTick(() => {
      this.$refs.textarea.focus()
      this.$refs.textarea.select()
    })

    // 耐久テスト用
    // for (let i=0; i<100; i++) {
    //   this.testDraw()
    // }
  },
  methods: {
    // testDraw () {
    //   this.top = Math.floor(Math.random() * 100) * 10
    //   this.left = Math.floor(Math.random() * 100) * 5
    //   this.value = String(Math.random())
    //   this.onDrawHere()
    // },
    resize (newRect) {
      this.width = newRect.width
      this.height = newRect.height
      this.top = newRect.top
      this.left = newRect.left

      this.resizeTextarea()
    },
    resizeTextarea () {
      const hiddenText = this.$refs.hiddenText
      this.width = (hiddenText.clientWidth > this.minw) ? hiddenText.clientWidth + 2 : this.minh
      this.height = (hiddenText.clientHeight > this.minh) ? hiddenText.clientHeight + 2 : this.minh

      const fontFamilyTmp = `'Noto Sans Japanese', Arial, Verdana, Roboto, "游ゴシック", "Yu Gothic", "游ゴシック体", "YuGothic", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "Meiryo UI", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif`
      const fo = this.fontOption
      this.style = `color: ${fo.color}; background: ${fo.backgroundColor}; font-size: ${fo.fontSize}px; font-weight: ${fo.fontWeight}; font-family: ${fo.fontFamily}, ${fontFamilyTmp};`
        + ` width: ${this.width}; height: ${this.height};`
    },
    async onDrawHere () {
      if (this.isSaving) return
      
      if (this.uid !== this.slide.createdBy) {
        if (this.personalMindoScore < -10) {
          alert(`ページ内の個人のスコアが低い時はアニメーション付きの落書きを利用することができません。現在のページ内での個人のスコアは${this.personalMindoScore}です。`)
          this.currentAnimation = 'normal'
          return
        }
        if (this.animatedDoodleNum >= 50 && this.currentAnimation !== 'normal') {
          alert('これ以上このページにはアニメーション付きの落書きは追加できません。次のページからはまた追加できるようになります。')
          this.currentAnimation = 'normal'
          return
        }
      }

      if (this.value === '') {
        alert('Type something')
        return
      }

      if (this.value.length >= 80) {
        alert(`一つの落書きは80字以内で入力してください。現在の文字数：${this.value.length}`)
        return
      }

      this.isSaving = true

      const slideImg = this.$parent.$refs.slideImg
      const doodle = {
        type: 'text',
        page: this.showingPage.id,
        value: this.value.replace(/\n/g,'\\n'),
        top: this.top / slideImg.clientHeight * 100, // %
        left: this.left / slideImg.clientWidth * 100, // %
        width: (this.width > this.minw) ? this.width : this.minw,
        height: this.height,
        slideImgWidth: slideImg.clientWidth,
        slideImgHeight: slideImg.clientHeight,
        fontOption: this.fontOption,
        animation: this.currentAnimation,
        likeNum: 0,
        dislikeNum: 0,
        likedBy: [],
        dislikedBy: [],
        createdBy: this.uid,
        createdAt: new Date(),
        updatedAt: new Date()
      }
      // console.log('doodle:', doodle)
      await database.slideCollection()
        .addDoodle(this.$route.params.slideId, doodle)
      
      this.$emit('resetTool')

      this.isSaving = false
    },
    cancelTool () {
      this.$emit('resetTool')
    },
    focusTextarea () {
      this.$nextTick(() => {
        this.$refs.textarea.focus()
      })
    },
    setCurrentAnimation (currentAnimation) {
      this.currentAnimation = currentAnimation
    }
  }
}
</script>
